<div class="modal-header border-0">
	<span class="modal-title theme-main-color fs-4 fw-bold ms-4 mt-3"
		>Détail de la {{ LABEL_INTERVENTION }}</span
	>
	<button
		type="button"
		class="btn-close custom-button-close border border-white rounded-circle bg-white fs-4"
		data-bs-dismiss="modal"
		aria-label="Close"
		(click)="bsModalRef.hide()"
	></button>
</div>
<div class="modal-body">
	<div class="row">
		<div class="">
			<div class="row">
				<div class="row mt-4 px-lg-5 px-2">
					<span class="theme-main-color fs-4 col">Informations</span>
					<a
						[routerLink]="['/gestion/formations', missionRequest?.id]"
						[queryParams]="{ redirected: true }"
						class="btn col-4 theme-main-color-button"
						(click)="bsModalRef.hide()"
						><i class="bi bi-pencil-fill px-1" aria-hidden="true"></i>Modifier
						la {{ LABEL_INTERVENTION }}</a
					>
				</div>
			</div>
			<div class="row my-5 px-lg-5 px-2">
				<div class="col-6">
					<div class="row my-4">
						<div class="col-6">
							<span
								for="date"
								class="theme-main-color fw-bold form-label row my-2"
								>Date</span
							>
							<span class="row my-2" id="date">{{
								missionRequest?.date | date : 'dd/MM/yyyy'
							}}</span>
						</div>
						<div class="col-6" *ngIf="isSESSAD">
							<span
								for="lieu"
								class="theme-main-color fw-bold form-label row my-2"
								>Lieu</span
							>
							<span class="row my-2" id="lieu">
								{{
									missionRequest?.missionPlace
										? missionRequest.missionPlace.nameDisplay
										: missionRequest.beneficiaire?.address?.label
								}}</span
							>
						</div>
					</div>
					<div class="row my-4">
						<div class="col-6">
							<span
								for="heureDebut"
								class="theme-main-color fw-bold form-label row my-2"
								>Heure de début
							</span>
							<span class="row my-2" id="heureDebut">{{
								missionRequest?.readyTime | minutesToTime
							}}</span>
						</div>
						<div class="col-6">
							<span
								for="heureFin"
								class="theme-main-color fw-bold form-label row my-2"
								>Heure de fin
							</span>
							<span class="row my-2" id="heureFin">{{
								missionRequest?.dueTime | minutesToTime
							}}</span>
						</div>
					</div>
					<div class="row my-4">
						<div class="col-6">
							<span
								for="typeFormation"
								class="theme-main-color fw-bold form-label row my-2"
								>Type de {{ LABEL_INTERVENTION }}
							</span>
							<span class="row my-2" id="typeFormation">{{
								missionRequest?.missionType?.type
							}}</span>
						</div>
						<div class="col-6" *ngIf="isSESSAD">
							<span
								for="specialite"
								class="theme-main-color fw-bold form-label row my-2"
								>Spécialité
							</span>
							<span class="row my-2" id="specialite">{{
								missionRequest?.careSpecialty.name
							}}</span>
						</div>
					</div>
				</div>
				<div class="col-6">
					<div class="row my-4">
						<div class="col-6">
							<span
								for="beneficiaire"
								class="theme-main-color fw-bold form-label row my-2"
								>{{ LABEL_BENEFICIAIRE }}
							</span>
							<span class="row my-2" id="beneficiaire"
								>{{ beneficiaire?.firstName }}
								{{ beneficiaire?.lastName }}</span
							>
						</div>
					</div>
					<div class="row my-4">
						<div class="col-6">
							<span
								for="remarque"
								class="theme-main-color fw-bold form-label row my-2"
								>Notes</span
							>
							<span class="row my-2" id="remarque">{{
								missionRequest?.notes ? missionRequest?.notes : 'Pas de notes.'
							}}</span>
						</div>
					</div>
					<!-- Type de préparation -->
					<div class="row my-4">
						<div class="col" *ngIf="isSESSAD">
							<span
								for="preparationTimePercentage"
								class="theme-main-color fw-bold form-label row my-2"
								>Temps de préparation:
							</span>
							<span class="row my-2">
								{{ missionRequest.preparationTimePercentage }}%
							</span>
						</div>
					</div>
					<!-- Affichage de l'intervenant associé à la mission -->
					<div class="row my-4">
						<!-- Type de mission -->
						<div
							class="col"
							*ngIf="!isSSIAD && this.missionRequest?.nombreIntervenant === 1"
						>
							<span
								for="missionType"
								class="theme-main-color fw-bold form-label row my-2"
							>
								{{ LABEL_INTERVENANT }}
							</span>
							<span class="row my-2">{{ getEmployeeOfMission() }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
